import React, {
  useCallback,
} from 'react'

import PropTypes from 'prop-types'
import classnames from 'classnames'

import Styles from './styles.module.sass'

const DEFAULT_COLOR = 'primary'
const DEFAULT_TYPE = 'solid'


export default function Button(props) {
  const {
    children,
    className,
    color = DEFAULT_COLOR,
    disabled,
    handleClick = noop,
    preventDefault,
    stopPropagation = true,
    type = DEFAULT_TYPE,
    ...otherProps
  } = props

  const onClick = useCallback((e) => {
    if ( disabled ) {
      e.preventDefault()
      return
    }

    // Sometimes...rarely...we want the click event to propagate
    // because the button is merely visual decoration and a parent
    // is actually doing the click handling.
    if ( stopPropagation ) {
      e.stopPropagation()
    }

    // Unfortuantely, this has to be an opt-in because there are
    // unknown numbers of usages where the submission of a <form> is
    // expected.
    //
    // TODO: hunt down the cases where the button is expected to
    // submit a form and make them stop so we can remove this
    // conditional expression.
    if ( preventDefault ) {
      e.preventDefault()
    }

    handleClick()
  }, [disabled, handleClick, preventDefault, stopPropagation])

  const rootClassName = classnames(Styles.root,
                                   Styles[color],
                                   Styles[type],
                                   className, {
                                     [Styles.disabled]: disabled,
                                   })

  return (
    <button
      { ...otherProps }
      className={ rootClassName }
      onClick={ onClick }
    >
      { children }
    </button>
  )
}

Button.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  color: PropTypes.oneOf([
    'primary',
    'secondary',
    'dangerous',
  ]),
  handleClick: PropTypes.func,
  preventDefault: PropTypes.bool,
  stopPropagation: PropTypes.bool,
  type: PropTypes.oneOf([
    'solid',
    'outline',
    'text',
  ]),
}

// eslint-disable-next-line no-empty-function
function noop() {
}
